export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_TOKEN = 'AUTH_TOKEN'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const USER_REQUEST = 'USER_REQUEST'
export const INITIAL_USER_REQUEST = 'INITIAL_USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'

export const ALL_PACKAGES_REQUEST = 'ALL_PACKAGES_REQUEST'
export const ALL_PACKAGES_SUCCESS = 'ALL_PACKAGES_SUCCESS'

export const ALL_TRAINERS_REQUEST = 'ALL_TRAINERS_REQUEST'
export const ALL_TRAINERS_SUCCESS = 'ALL_TRAINERS_SUCCESS'

export const ALL_WORKOUTS_TEMPLATES_REQUEST = 'ALL_WORKOUTS_TEMPLATES_REQUEST'
export const ALL_WORKOUTS_TEMPLATES_SUCCESS = 'ALL_WORKOUTS_TEMPLATES_SUCCESS'

export const TRAINER_REQUEST = 'TRAINER_REQUEST'
export const TRAINER_SUCCESS = 'TRAINER_SUCCESS'
export const RUNNER_REQUEST = 'RUNNER_REQUEST'
export const RUNNER_SUCCESS = 'RUNNER_SUCCESS'
export const RUNNER_DATA_FILLED = 'RUNNER_DATA_FILLED'
export const RUNNERS_TRAINER_REQUEST = 'RUNNERS_TRAINER_REQUEST'
export const RUNNERS_TRAINER_SUCCESS = 'RUNNERS_TRAINER_SUCCESS'

export const TRAINERS_RUNNERS_REQUEST = 'TRAINERS_RUNNERS_REQUEST'
export const TRAINERS_RUNNERS_SUCCESS = 'TRAINERS_RUNNERS_SUCCESS'

export const ADMIN_RUNNERS_REQUEST = 'ADMIN_RUNNERS_REQUEST'
export const ADMIN_RUNNERS_SUCCESS = 'ADMIN_RUNNERS_SUCCESS'

export const ADMIN_TRAINERS_REQUEST = 'ADMIN_TRAINERS_REQUEST'
export const ADMIN_TRAINERS_SUCCESS = 'ADMIN_TRAINERS_SUCCESS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js